<template>
  <div class="app-container withdraw">

    <div class="header" style="display:flex;justify-content:center;align-items:center;width:100%;margin-bottom: 10px;">
      <el-input v-model="listQuery.batch" placeholder="批次号" :clearable="true"
        style="width: 200px;margin: 0px 10px;margin-left: 20px;"></el-input>

      <el-input v-model="listQuery.card_code" placeholder="券码" :clearable="true"
        style="width: 200px;margin: 0px 10px;margin-left: 20px;"></el-input>

      <el-input v-model="listQuery.usage_user_id" placeholder="用户ID" :clearable="true"
        style="width: 200px;margin: 0px 10px;margin-left: 20px;"></el-input>

      <div style="display:flex;align-items:center;">
        <div style="width: 100px;margin: 0px 10px;margin-left: 20px;text-align: right;">
          核销时间
        </div>

        <el-date-picker v-model="listQuery.start_at" type="date" value-format="yyyy-MM-dd" placeholder="请选择开始时间"
          style="margin-right: 10px;"></el-date-picker>

        到

        <el-date-picker v-model="listQuery.end_at" type="date" value-format="yyyy-MM-dd" placeholder="请选择结束时间"
          style="margin-left: 10px;"></el-date-picker>
      </div>

      <el-select v-model="listQuery.state" style="width: 100px;margin: 0px 10px;margin-left: 20px;" :clearable="true">
        <el-option v-for="item in stateList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>

      <el-button size="small" type="primary" style="margin-left: 15px;" @click="searchHandler">搜索</el-button>
    </div>

    <div>
      <el-button-group>
        <el-button type="primary" :disabled="multipleSelection.length === 0" @click="giveCoupons">转赠</el-button>
      </el-button-group>
    </div>

    <el-table :loading="listLoading" :data="list" border fit highlight-current-row style="margin-top: 15px;"
      @selection-change="handleSelectionChange">

      <el-table-column type="selection" width="55">
      </el-table-column>

      <el-table-column label="批次号" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.batch }}</template>
      </el-table-column>

      <el-table-column label="会员卡号" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.card_nos }}</template>
      </el-table-column>
      <el-table-column label="会员劵码" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.card_code }}</template>
      </el-table-column>

      <el-table-column label="会员时间" align="center" min-width="110">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.card_type === 2">永久</el-tag>
          <template v-else>{{ scope.row.months }}个月</template>
        </template>

      </el-table-column>

      <el-table-column label="是否解锁课程" align="center" min-width="95">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.is_course == 1">解锁</el-tag>
          <el-tag type="danger" v-if="scope.row.is_course == 0">锁定</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="会员卡类型" align="center" min-width="95">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.card_type == 1">普通会员</el-tag>
          <el-tag type="warning" v-if="scope.row.card_type == 2">金牌会员</el-tag>
          <el-tag type="primary" v-if="scope.row.card_type == 3">银牌会员</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="能量" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.energy_num }}</template>
      </el-table-column>

      <el-table-column label="状态" align="center" min-width="95">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.state == 0">待使用</el-tag>
          <el-tag type="info" v-if="scope.row.state == 1">已使用</el-tag>
        </template>
      </el-table-column>

      <!-- <el-table-column label="上级编码" align="center" min-width="110">
        <template slot-scope="scope">{{
          scope.row.parent_invitation ? scope.row.parent_invitation : "-"
        }}</template>
      </el-table-column> -->

      <!-- <el-table-column label="核销人ID" align="center" min-width="110">
        <template slot-scope="scope">{{
          scope.row.usage_user ? scope.row.usage_user.invitation_code : "-"
        }}</template>
      </el-table-column> -->

      <el-table-column label="核销人编码" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.usage_user?scope.row.usage_user.invitation_code:'-'}}</template>
      </el-table-column>

      <el-table-column label="核销人名称" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.usage_user?scope.row.usage_user.nickname:'-'}}</template>
      </el-table-column>

      <el-table-column label="核销时间" align="center" min-width="110">
        <template slot-scope="scope">{{
          scope.row.usage_at ? scope.row.usage_at : "-"
        }}</template>
      </el-table-column>

      <el-table-column label="创建时间" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.created_at }}</template>
      </el-table-column>

      <!-- <el-table-column label="操作" align="center" width="110">
      </el-table-column> -->
    </el-table>

    <div class="pagination" style="display: flex;align-items: center;justify-content: center;margin-top: 15px;">
      <el-pagination :current-page="listQuery.page" :page-size="listQuery.limit" :page-sizes="[10, 20, 30, 50]"
        :total="total" background layout="total,sizes,prev,pager,next,jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange"></el-pagination>
    </div>




    <el-dialog title="赠送能量" :visible.sync="showDialog" :before-close="handleClose">
      <el-form ref="form" :model="form" label-width="120px">

        <el-form-item label="上级编号">
          <el-input v-model="form.parent_invitation" style="width: 200px" :clearable="true" placeholder="请输入上级编号"
            @change="getParent">
          </el-input>
        </el-form-item>

        <el-form-item label="头像">
          <div>
            <el-avatar :src="this.parent_user_head"></el-avatar>
            <p>{{ this.parent_user_name }}</p>
          </div>
        </el-form-item>


        <el-form-item style="text-align: right">
          <el-button size="small" @click="handleCancel">返回</el-button>

          <el-button size="small" @click="handleSubmit" type="primary" :disabled="!form.parent_invitation">提交</el-button>
          <!-- :loading="btnLoading" -->
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// 会员卡
import { getCardList, giveCard, getUserInfo } from "@/api/memberCard";


export default {
  data() {
    return {
      stateList: [
        {
          value: "0",
          label: "未核销"
        },
        {
          value: "1",
          label: "已核销"
        }
      ],
      formInline: {},
      listLoading: false,
      total: 1,
      listQuery: {
        page: 1,
        limit: 10,
        start_at: "", // 开始核销时间
        end_at: "", // 结束时间

        batch: "", // 批次号
        card_code: "", // 券码
        usage_user_id: "", // 使用用户id
        state: "" // 是否核销
      },
      multipleSelection: [], // 多选后的值
      list: [],
      showDialog: false, // 显示转赠弹窗
      form: {
        parent_invitation: '', // 转增上级编码
      },
      parent_user_head: '', // 要转增的用户头像
      parent_user_name: '', // 要转增的用户姓名
    };
  },
  mounted() {
    this.getList();
    // console.log(this.$store.state.user.username)
  },
  methods: {
    // 获取转增用户信息
    getParent() {
      if(this.form.parent_invitation ==='')
      {
          this.parent_user_head = '';
          this.parent_user_name = '';
          return;
      }
      
      getUserInfo({
        invitation_code:this.form.parent_invitation
      }).then(result => {
            if (result.data === null) {
              this.$notify.error("用户不存在");
              this.parent_user_head = '';
              this.parent_user_name = '';
            } else {
                this.parent_user_head = result.data.avatar;
                this.parent_user_name = result.data.nickname;
            }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(err => {
          console.log(err);
        });
    },
    // 赠送
    handleSubmit() {
      this.$confirm(`此操作将${this.parent_user_name ? ('向' + this.parent_user_name) : ''}转赠会员卡，是否继续？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((result) => {

          giveCard({
            batch_array: this.multipleSelection,
            parent_invitation: this.form.parent_invitation
          })
            .then((result) => {
              this.$notify.success("操作成功");
              this.getList();
            })
            .catch((err) => {
              this.$notify.error("操作失败");
            })
            .finally(() => {
              this.showDialog = false;
            });


        })
        .catch((err) => {
          this.$notify.info("已取消");
        });
    },
    handleCancel() {
      this.showDialog = false;
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    // 搜索
    searchHandler() {
      this.initData();
      this.getList();
    },
    initData() {
      this.listQuery.page = 1;
      this.listQuery.limit = 10;
    },
    getList() {
      console.log(123213);
      this.listLoading = true;
      this.listQuery.start_at = this.listQuery.start_at
        ? this.listQuery.start_at + " 00:00:00"
        : "";
      this.listQuery.end_at = this.listQuery.end_at
        ? this.listQuery.end_at + " 23:59:59"
        : "";
      getCardList(this.listQuery)
        .then(result => {
          this.list = result.data.data;
          this.total = result.data.total;
          this.listLoading = false;


        })
        .catch(err => {
          console.log(err);
        })
        .finally(err => {
          console.log(err);
        });


      // this.list.push(...[...new Array(10)].map((item, i) => ({ id: i })))

    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val.map(item => item.id);
    },
    giveCoupons() {

      this.form.parent_invitation = ''
      this.parent_user_name = ''
      this.parent_user_head = ''

      this.showDialog = true

      // this.$confirm('是否转赠会员卡?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {

      //   giveCard({
      //     batch_array: this.multipleSelection,
      //     parent_invitation: 'YZHSKR94'
      //   })

      //   this.$message({
      //     type: 'success',
      //     message: '成功!'
      //   });
      // }).catch(() => {
      //   this.$message({
      //     type: 'info',
      //     message: '已取消'
      //   });
      // });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.member_card_box {
  width: calc(100% - 40px);
  padding: 20px;
}
</style>
